import { Ajax } from '../helpers/ajax';
import * as Mustache from 'mustache';

/**
 * The templates tool loads a template with view data. It caches template scripts.
 *
 * Example: loader.load('/path/to/template.html', 'selector', container, data);
 */
export class Templates {
	constructor() {
		this.templates = {};
		this.templateFiles = {};
		this.data = {};
	}

	/**
	 * Render a template
	 * @param {Object} template html template
	 * @param container
	 * @param data
	 */
	static renderTemplate(template, container, data) {
		// clear and fill the container
		container.innerHTML = Mustache.render(template, data);
	}

	/**
	 * Render a template
	 * @param id
	 */
	static getTemplateFromPage(id) {
		const templ = document.getElementById(id);
		if (templ) return templ.innerHTML;
	}

	/**
	 * creates a div with the html file in it and substracts it to get the html itself;
	 * @param id
	 * @param file
	 * @returns {string}
	 */
	static getHtmlFromFile(id, file) {
		const tmp = document.createElement('div');
		tmp.innerHTML = file;
		return tmp.querySelector('#' + id).innerHTML;
	}

	/**
	 * get template by url
	 * @param {String} templateUrl Location of the template
	 * @param {String} templateId  ID of template
	 */
	getTemplate(templateUrl, templateId) {
		return new Promise((resolve, reject) => {
			// check whether it already is cached
			if (this.templates[templateId]) {
				resolve(this.templates[templateId]);
			} else if (this.templateFiles[templateUrl]) {
				resolve(Templates.getHtmlFromFile(templateId, this.templateFiles[templateUrl]));
			} else {
				Ajax.GET(templateUrl, 'text').then((file) => {
					let html = Templates.getHtmlFromFile(templateId, file);
					this.templateFiles[templateUrl] = file;
					this.templates[templateId] = html;
					resolve(html);
				}, reject);
			}
		});
	}

	/**
	 * Load a template and put it in a container.
	 * @param {String} templateUrl        The absolute path to the template
	 * @param {String} templateId         The id of the chosen template
	 * @param {domElement} templateContainer Empty container where the template will be placed in
	 * @param {Object} viewData           The data that is loaded in the template
	 */
	load(templateUrl, templateId, templateContainer, viewData) {
		return new Promise((resolve, reject) => {
			return this.getTemplate(templateUrl, templateId).then((template) => {
				Templates.renderTemplate(template, templateContainer, viewData);
				resolve();
			}, reject);
		});
	}
}

